import ActionTypes from './types';
import {getCentroidFromGeoJson} from '../utils';
import {SHOW_PARKING_SPOTS_ZOOM_LEVEL} from '../constants';

export const onParkingAreaClick = (feature) => {
  const coordinates = feature.geometry.coordinates[0];
  const centroid = getCentroidFromGeoJson(coordinates);

  return (dispatch) => {
    dispatch({
      type: ActionTypes.MAP_SET_GEOGRAPHY,
      zoomLevel: SHOW_PARKING_SPOTS_ZOOM_LEVEL,
      position: [centroid.lat, centroid.lng]
    });
  };
};




// WEBPACK FOOTER //
// ./src/actions/parkingArea.js